import { isDesktop } from '../desktop.ts';

export const useIsDesktop = () => {
	return {
		isDesktop: isDesktop(),
	};
};
